import { FC } from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useWindowDimensions } from 'src/hooks';
import { useTheme } from 'styled-components';
import { InlineDateAndTime } from '..';
import {
  AuditEntryContainer,
  AuditEntryDetail,
  AuditEntryDetailsContainer,
  AuditEntryHeader,
  AuditEntryIcon,
} from './AuditLogEntry.styles';

interface Props {
  auditEntryType: 'case' | 'report';
  icon?: string;
  id: string;
  text: string;
  date: string;
}

export const AuditLogEntry: FC<Props> = (props) => {
  const theme = useTheme();
  const { width } = useWindowDimensions();
  return (
    <AuditEntryContainer>
      {width > 680 && (
        <AuditEntryIcon auditEntryType={props.auditEntryType}>
          {props.icon && (
            <StyledIcon
              className={props.icon}
              size="24px"
              color={theme.atlas.semantic.color.surface.default}
            />
          )}
        </AuditEntryIcon>
      )}
      <AuditEntryDetailsContainer auditEntryType={props.auditEntryType}>
        <AuditEntryHeader>
          <p>{`${props.auditEntryType === 'case' ? 'Case ID' : 'Report ID'}: ${
            props.id
          }`}</p>
          <InlineDateAndTime date={props.date} />
        </AuditEntryHeader>
        <AuditEntryDetail>{props.text}</AuditEntryDetail>
      </AuditEntryDetailsContainer>
    </AuditEntryContainer>
  );
};
